<template>
  <div
    id="top-sources"
    class="h-100"
  >
    <div class="bg-white shade pb-2 pt-1 px-3 h-100">
      <!-- header component -->
      <h6 class="d-flex align-items-center">
        <div
          class="text-elipsis"
          v-tooltip.top="{ ref: 'titleTooltip' }"
        >
          <i class="bi bi-patch-check" /> {{ title }}
        </div>
        <div
          ref="titleTooltip"
          class="tooltip-content"
        >
          {{ title }}
        </div>
        <div
          v-if="is_disabled"
          class="badge rounded ml-auto py-1"
          :class="sentiment == 1
            ? 'badge-success'
            : sentiment == 0
              ? 'badge-secondary'
              : 'badge-danger'
          "
          style="width: 60px; height: 20px"
        >
          {{
            sentiment == 1 ? "Positif" : sentiment == 0 ? "Netral" : "Negatif"
          }}
        </div>

        <select
          v-else
          v-model="sentiment"
          class="ml-auto"
          style="
            height: 20px !important;
            font-size: 12px !important;
            border: 0 !important;
            box-shadow: rgba(184, 192, 202, 0.5) 0px 0px 3px !important;
          "
          @change="getData"
        >
          <option value="1">
            Positif
          </option>
          <option value="0">
            Netral
          </option>
          <option value="-1">
            Negatif
          </option>
        </select>
      </h6>
      <div class="d-flex">
        <!-- <select
          v-if="type == 3"
          disabled
          v-model="selected_source"
          class="form-sorting-post form-control form-control-sm"
          style="
            border: 0 !important;
            box-shadow: rgba(184, 192, 202, 0.5) 0px 0px 3px !important;
          "
          @change="getData"
        >
          <option value="all">
            Semua Media
          </option>
        </select> -->
        <div
          class="col-md-12 p-r-0 m-t-10 mt-md-0"
          
        >
          <form
            action="#"
            id="post-search-form"
            @submit.prevent="searchPost"
          >
            <div class="form-group-sm input-group input-group-right">
              <input
                type="text"
                placeholder="Cari..."
                v-model="search"
                class="form-control input-sm"
              >
              <div class="input-group-append">
                <span
                  @click="searchPost"
                  class="input-group-text primary"
                  style="cursor: pointer; border: none !important"
                >
                  <i class="bi bi-search" />
                </span>
                <span
                  v-if="isFilter"
                  @click="resetFilter"
                  class="input-group-text danger"
                  style="cursor: pointer"
                >
                  <i class="bi bi-trash" />
                </span>
              </div>
            </div>
          </form>
        </div>
        <!-- <select
          v-else
          v-model="selected_source"
          class="form-sorting-post form-control form-control-sm"
          style="
            border: 0 !important;
            box-shadow: rgba(184, 192, 202, 0.5) 0px 0px 3px !important;
          "
          @change="getData"
        >
          <option value="all">
            Semua Media
          </option>
          <option value="twitter">
            Twitter
          </option>
          <option value="facebook">
            Facebook
          </option>
          <option value="instagram">
            Instagram
          </option>
          <option value="youtube">
            Youtube
          </option>
          <option value="tiktok">
            Tiktok
          </option>
          <option value="linkedin">
            Linkedin
          </option>
          <option value="forum">
            Forum
          </option>
          <option value="blog">
            Blog
          </option>
        </select> -->
      </div>
      <!-- item component -->
      <div class="mt-3">
        <!-- loader component -->
        <loader-component v-if="is_loading" />
        <!-- item data component -->
        <div v-else>
          <!-- account component -->
          <div
            v-if="top_source_data"
            class="scroller"
            style="max-height: 27.5rem"
          >
            <div
              class="d-flex align-items-center mb-2 clickable hoverable"
              v-for="item in top_source_data"
              :key="item.id"
              @click="showAccountDetail(item.account, item.id_account)"
            >
              <!-- {{ item._id.profile_image }} -->
              <img
                v-if="item.profile_image"
                style="
                  border-radius: 50%;
                  height: 35px;
                  width: 35px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                class="border"
                :src="item.profile_image"
                @error="handleImageError"
              >

              <img
                v-else
                style="
                  border-radius: 50%;
                  height: 35px;
                  width: 35px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                class="border"
                src="../../../../../public/assets/img/profiles/default.png"
              >
              <div
                class="ml-2 mr-1"
                style="
                  width: 60%;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                "
              >
                {{ item.account }}
                <div>
                  <div
                    style="font-size: 10px"
                    class="ml-auto"
                  >
                    <i :class="setIcon(item.source)" />
                    {{ setSource(item.source) }}
                  </div>
                </div>
              </div>
              <div
                class="ml-auto"
                style="width: 20%"
              >
                <div class="d-flex">
                  <div
                    style="font-size: 14px"
                    class="ml-auto"
                  >
                    {{ item.count }}
                  </div>
                </div>
                <div class="d-flex">
                  <div
                    style="font-size: 10px"
                    class="ml-auto"
                  >
                    <!-- {{ top_data_type }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- empty data alert component -->
          <div
            v-else
            class="alert alert-danger"
            role="alert"
            align="center"
          >
            <strong>Mohon maaf, data tidak tersedia! </strong>
            <br>
            Silahkan lakukan pencarian dengan parameter lain.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import loader from "@/views/components/loader.vue";
import gp from "@/plugins/generalPlugins.js";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "TopSources",
  components: {
    "loader-component": loader,
  },
  props: {
    is_disabled: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    sentimen: {
      type: String,
      default: function () {
        return "1";
      },
    },
    title: {
      type: String,
      default: function () {
        return "";
      },
    },
    type: {
      type: String,
      default: function () {
        return "";
      },
    },
    top_data_type: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      is_loading: true,
      is_sentiment_positif: true,
      selected_source: "all",
      is_not_null: true,
      top_source_data: null,
      id_project: this.$store.getters.user.id_project,
      items: 10,
      sentiment: parseInt(this.sentimen),
      search: null,
      isFilter: false
    };
  },
  mounted() {
    if (this.$route.query.from && this.$route.query.to) {
      this.getData();
    }
  },
  watch: {
    "$route.query.from"() {
      if (this.$route.query.from && this.$route.query.to) {
        this.getData();
      }
    },
    "$route.query.topic_selected"() {
        this.getData();
    },    
    "$route.query.group"() {
        this.getData();
    },
    items() {
      if (this.items >= 5 && this.items <= 25) {
        this.getData();
      }
    },
  },
  methods: {
    getData() {
      this.is_loading = true;
      let endpoint = parseInt(this.type) == 3 ? "medkon" : "medsos";
    
      let params = {
        from: this.$route.query.from,
        to: this.$route.query.to,
        items: this.items,
        sentiments: btoa(this.sentiment),
        tipe: endpoint,
        ...(this.selected_source !== "all"
          ? { source: this.selected_source }
          : {}),
        ...(this.$route.query.topic_selected != undefined
        ? { topic_selected: this.$route.query.topic_selected }
        : delete this.$route.query.topic_selected),        
        ...(this.$route.query.group != undefined
        ? { group: this.$route.query.group }
        : delete this.$route.query.group),
      };
      if (this.search !== undefined && this.search !== null) {
          params.account = this.search;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      const api = `${process.env.VUE_APP_API_URL}kecenderungan/${this.id_project}?${query}`;

      this.$http
        .get(api)
        .then((res) => {
          this.top_source_data = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading = false;
        });

    },
    setSource(source) {
      if (source == "news") {
        return "Media Online";
      } else if (source == "media_cetak") {
        return "Media Cetak";
      } else if (source == "media_tv") {
        return "Media TV";
      } else if (source == "review") {
        return "Review Aplikasi";
      }
      return source.charAt(0).toUpperCase() + source.slice(1);
    },
    setIcon(source) {
      if (source == "news") {
        return "bi bi-globe-americas";
      } else if (source == "media_cetak") {
        return "bi bi-newspaper";
      } else if (source == "media_tv") {
        return "bi bi-tv";
      } else if (source == "twitter") {
        return "bi bi-twitter-x";
      } else if (source == "facebook") {
        return "bi bi-facebook";
      } else if (source == "instagram") {
        return "bi bi-instagram";
      } else if (source == "youtube") {
        return "bi bi-youtube";
      } else if (source == "tiktok") {
        return "bi bi-tiktok";
      } else if (source == "linkedin") {
        return "bi bi-linkedin";
      } else if (source == "forum") {
        return "bi bi-chat-dots-fill";
      } else if (source == "blog") {
        return "bi bi-rss";
      } else if (source == "review") {
        return "bi bi-phone";
      }
      return "bi bi-circle";
    },
    handleImageError() {
      event.target.src = "/assets/img/profiles/default.png";
    },
    thousandFormatter(number) {
      return gp.kmbFormatter(number);
    },
    showAccountDetail(account, id) {
      this.$router.push({
        path: "/detail-akun",
        query: { account: account, key: btoa(id) },
      });
    },
    searchPost() {
      let text = this.search;
      this.isFilter = true;
      this.search = text;
      this.getData();
    },
    resetFilter() {
        this.isFilter = false;
        this.search = null;
        this.searchPost();
    },
  },
};
</script>
<style>
.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}

.bg-secondary {
  background-color: #6c757d !important;
}

.border-secondary {
  border-color: #6c757d !important;
}
</style>